import { List, ListItem, ListItemIcon, ListItemText, Select, styled } from "@mui/material";
import { Typography } from "@totalsoft/rocket-ui";
import { NavLink } from "react-router-dom";

export const MenuNavLink = styled(NavLink, { shouldForwardProp: prop => prop !== "active" })(({ theme, active }) => ({
  transition: "all 300ms linear",
  margin: ".5rem 1rem 0",
  borderRadius: "3px",
  position: "relative",
  display: "flex",
  padding: ".6rem .75rem",
  alignItems: "center",
  backgroundColor: active ? theme.palette.secondary.main : "transparent",
  color: active ? theme.palette.common.white : theme.palette.sideMenu.color,
  width: "auto",
  "&:hover,&:focus": {
    outline: "none",
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white
  }
}));

export const MenuListItem = styled(ListItem)(() => ({
  color: "inherit",
  position: "relative",
  display: "block",
  textDecoration: "none",
  margin: "0",
  padding: "0"
}));

export const MenuListItemIcon = styled(ListItemIcon)(() => ({
  color: "inherit",
  width: "26px",
  minWidth: "26px",
  display: "flex",
  justifyContent: "center",
  opacity: "0.8"
}));

export const MenuListItemText = styled(ListItemText, { shouldForwardProp: prop => prop !== "visible" })(
  ({ visible }) => ({
    transition: "opacity 300ms ease 0s",
    opacity: visible ? 1 : 0,
    marginLeft: "3rem",
    fontWeight: "bold",
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'normal',
    maxWidth: '100px',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
  })
);

export const UserMenuContainer = styled("div")(({ theme }) => ({
  paddingBottom: ".5rem",
  margin: "1rem 0 0",
  position: "relative",
  "&:after": {
    content: '""',
    position: "absolute",
    bottom: 0,
    right: "15px",
    height: "1px",
    width: "calc(100% - 30px)",
    backgroundColor: theme.palette.primary.main
  }
}));

export const UserAvatarContainer = styled("div")(() => ({
  transition: "all 300ms linear",
  width: "34px",
  height: "34px",
  overflow: "hidden",
  float: "left",
  zIndex: "5",
  marginRight: "11px",
  borderRadius: "50%",
  marginLeft: "23px",
  boxShadow:
    "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
}));

export const UserMenuList = styled(List)(() => ({
  paddingLeft: "0",
  paddingTop: "0",
  paddingBottom: "0",
  marginBottom: "0",
  listStyle: "none",
  color: "inherit",
  "&:before,&:after": {
    display: "table",
    content: '" "'
  },
  "&:after": {
    clear: "both"
  }
}));

export const UserMenuListItem = styled(ListItem)(() => ({
  color: "inherit",
  position: "relative",
  display: "block",
  textDecoration: "none",
  margin: "0",
  padding: "0"
}));

export const MenuCollapseNavLink = styled(NavLink)(({ theme }) => ({
  marginTop: "-0.5rem",
  borderRadius: "3px",
  position: "relative",
  display: "block",
  padding: ".5rem 2rem",
  background: "none",
  width: "auto",
  color: theme.palette.sideMenu.color,
  "&:active,&:focus,&:hover": {
    color: theme.palette.sideMenu.hoverTextColor
  }
}));

export const UserCaret = styled("b", { shouldForwardProp: prop => prop !== "active" })(({ active }) => ({
  position: "absolute",
  right: "50px",
  transition: "all 150ms ease-in",
  width: "0",
  height: "0",
  borderTop: "4px solid",
  borderRight: "4px solid transparent",
  borderLeft: "4px solid transparent",
  transform: active ? "rotate(180deg)" : "none",
  marginTop:"15px"
}));

export const LanguageSelectorContainer = styled("div")(() => ({
  width: "100%",
  verticalAlign: "middle"
}));

export const LanguageSelectorSelect = styled(Select, { shouldForwardProp: prop => prop !== "miniActive" })(
  ({ theme, miniActive }) => ({
    color: theme.palette.sideMenu.color,
    width: "100%",
    verticalAlign: "middle",
    transition: "all 300ms",
    borderRadius: "3px",
    "&:before,&:after": {
      display: "none !important"
    },
    "&:hover": {
      outline: "none",
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
      boxShadow: "none",
      "& .MuiSelect-icon": {
        color: theme.palette.common.white
      }
    },
    "& .MuiSelect-select": {
      paddingBlock: ".6rem",
      paddingInline: miniActive ? ".5rem" : "1rem",
      textOverflow: miniActive ? "clip !important" : "ellipsis",
      "& .MuiTypography-root": {
        paddingLeft: "2.3rem"
      }
    },
    "& .MuiSelect-icon": {
      display: miniActive ? "none" : "block",
      color: theme.palette.sideMenu.color
    }
  })
);

export const LanguageSelectorListItem = styled(ListItem)(({ theme }) => ({
  padding: ".25rem 1rem",
  "&:hover": {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main
  }
}));

export const LanguageSelectorText = styled(Typography)(() => ({
  margin: "0",
  position: "relative",
  transform: "translateX(0px)",
  color: "inherit",
  opacity: "1",
  whiteSpace: "nowrap",
  display: "inline-block",
  transition: "transform 300ms ease 0s, opacity 300ms ease 0s",
  fontSize: "15px",
  fontWeight: "bold",
  paddingLeft: "15px"
}));
